import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import HtmlStyles from 'styles/mixins/Html.styles';
import {getEditorStyles} from 'mui-tiptap';

const StyledEditorReadOnly = styled.div`
  &.EditorReadOnly {
    .ProseMirror {
      // no RichTextContent to inject these any more
      ${props => getEditorStyles(props.theme)}

      font-size: inherit !important;
      font-weight: inherit !important;
      font-family: inherit !important;
      line-height: inherit !important;

      .mention-component {
        display: inline;
        max-width: fit-content;
      }

      img:not(.ProseMirror-separator) {
        &.ProseMirror-selectednode {
          outline: none;
        }
      }
    }
  }

  ${HtmlStyles}
  ${ComponentStyles}
`;

StyledEditorReadOnly.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorReadOnly;
